import { countMissingDetails } from './countMissingDetails';
/**
 * Take a purchase order and return the number of items missing details
 * @param {PurchaseOrder} purchaseOrder The purchase order to check
 *
 * @typedef {Object} PurchaseOrder
 * @property {array} purchase_order_lines
 *
 * @returns {number} The number of items in a purchase order with missing item details
 *
 */
const poItemsMissingDims = (purchaseOrder) => {
  const missingDims = purchaseOrder.purchase_order_lines.map((item) => {
    if (!item.catalog_item) return 0;
    return countMissingDetails(item.catalog_item);
  });
  return missingDims.filter(Number).length;
};

export default poItemsMissingDims;
